<div class="row">
  <div class="col p-5">
    <h3 class="mb-4">{{ edit ? "Редактирование" : "Создание" }} игрока</h3>

    <div class="row">
      <div class="col">
<!-- there was   (submit)="edit ? update() : create()      -->
        <form [formGroup]="form" class="form">
          <div class="row mb-3">
            <div class="col-3">
              <label for="last_name">Фамилия*</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="last_name"
                id="last_name"
                placeholder="Петров"
                formControlName="last_name"
                (keydown)="blurOnEnter($event)"
                (blur)="fieldBlurHandler($event, 'last_name')"
                (focus)="fieldOnFocusHandler($event, 'last_name')"
              />
              <div
                *ngIf="fieldsValidationsResults.last_name"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Не может быть пустым.' }} <br/>
                {{ 'Разрешены латинские или русские буквы.' }}
              </div>
            </div>
<!--            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.last_name">-->
<!--              <div *ngFor="let error of errors.last_name">{{ error }}</div>-->
<!--            </div>-->
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="first_name">Имя*</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="first_name"
                id="first_name"
                placeholder="Иван"
                formControlName="first_name"
                (keydown)="blurOnEnter($event)"
                (blur)="fieldBlurHandler($event, 'name')"
                (focus)="fieldOnFocusHandler($event, 'name')"
              />
              <div
                *ngIf="fieldsValidationsResults.name"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Не может быть пустым.' }} <br/>
                {{ 'Разрешены латинские или русские буквы.' }}
              </div>
            </div>
<!--            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.first_name">-->
<!--              <div *ngFor="let error of errors.first_name">{{ error }}</div>-->
<!--            </div>-->
          </div>

          <div class="row mb-3">
            <div class="col-3">
              <label for="surname">Отчество*</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="surname"
                id="surname"
                placeholder="Иванович"
                formControlName="surname"
                (keydown)="blurOnEnter($event)"
                (blur)="fieldBlurHandler($event, 'surname')"
                (focus)="fieldOnFocusHandler($event, 'surname')"
              />
              <div
                *ngIf="fieldsValidationsResults.surname"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Не может быть пустым.' }} <br/>
                {{ 'Разрешены латинские или русские буквы.' }}
              </div>
              <div
                *ngIf="surnameError()"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Не может быть пустым'}}
              </div>
            </div>
          </div>

          <div class="row mb-3 titlesAndCategories">
            <div class="col-3">
              <label for="title">Спортивное звание</label>
            </div>
            <div class="col">
              <select class="form-control" formControlName="title" id="title" name="title">
                <option value="">—</option>
                <option *ngFor="let item of TITLE_CHOICES" value="{{ item[0] }}">{{ item[1] }}</option>
              </select>
            </div>
            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.title">
              <div *ngFor="let error of errors.title">{{ error }}</div>
            </div>
          </div>

          <div class="row mb-3 titlesAndCategories">
            <div class="col-3">
              <label for="judgement_category">Категория судьи</label>
            </div>
            <div class="col">
              <select class="form-control" formControlName="judgement_category" id="judgement_category" name="judgement_category">
                <option value="">—</option>
                <option *ngFor="let item of JUDGEMENT_CATEGORIES" value="{{ item[0] }}">{{ item[1] }}</option>
              </select>
            </div>
            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.judgement_category">
              <div *ngFor="let error of errors.judgement_category">{{ error }}</div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-3">
              <label for="city">Город*</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="city"
                id="city"
                placeholder="Москва"
                formControlName="city"
                [ngbTypeahead]="searchCity"
                [inputFormatter]="cityInputFormatter"
                [resultFormatter]="cityResultFormatter"
                (selectItem)="citySelect($event)"
                (focus)="citySearchFocusHandler()"
                (blur)="citySearchBlurHandler()"
                (keydown)="blurOnEnter($event)"
              />
              <div
                *ngIf="queryIsBeingProcessed && !citySearchBlurred"
                class="queryIsBeingProcessedNotification"
              >
                Ищем города...
              </div>
              <div
                *ngIf="cityError()"
                class="noCityWasFoundMessageStyle"
              >
                Город не найден
              </div>
            </div>
            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.city">
              <div *ngFor="let error of errors.city">{{ error }}</div>
            </div>
          </div>
          <div class="row mb-3" *ngIf="city">
            <div class="col-3">
              <label for="city">Регион</label>
            </div>
            <div class="col">
              {{ city.region.name }}
            </div>
          </div>
          <div class="row mb-3" *ngIf="city">
            <div class="col-3">
              <label for="city">Страна</label>
            </div>
            <div class="col">
              {{ city.region.country.name }}
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-3">
              <label for="birthdate">Дата рождения*</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="birthdate"
                id="birthdate"
                placeholder="22.01.1990"
                formControlName="birthdate"
                (keydown)="blurOnEnter($event)"
                (blur)="fieldBlurHandler($event, 'birthDate')"
                (focus)="fieldOnFocusHandler($event, 'birthDate')"
              />
              <div
                *ngIf="fieldsValidationsResults.birthDate"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Дата требуется в формате дд.мм.гггг'}}
              </div>
              <div
                *ngIf="birthDateError()"
                class="text-danger extraErrorsStyles"
              >
                {{ 'Дата рождения должна быть реальной'}}
              </div>
            </div>
<!--            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.birthdate">-->
<!--              <div *ngFor="let error of errors.birthdate">{{ error }}</div>-->
<!--            </div>-->
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="phone">Телефон</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="phone"
                id="phone"
                placeholder="+79161234567"
                formControlName="phone"
                (keydown)="blurOnEnter($event)"
                (blur)="fieldBlurHandler($event, 'phoneNumber')"
                (focus)="fieldOnFocusHandler($event, 'phoneNumber')"
              />
              <div
                *ngIf="fieldsValidationsResults.phoneNumber"
                class="text-danger extraErrorsStyles"
              >
                {{'Номер требуется в формате +79161234567'}}
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="email">E-mail</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="email"
                id="email"
                placeholder="ivan@petrov.ru"
                formControlName="email"
                (keydown)="blurOnEnter($event)"
              />
            </div>
            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.email">
              <div *ngFor="let error of errors.email">{{ error }}</div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="trainer">Тренер</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="trainer"
                id="trainer"
                placeholder=""
                formControlName="trainer"
                [ngbTypeahead]="searchTrainer"
                [inputFormatter]="trainerInputFormatter"
                [resultFormatter]="trainerResultFormatter"
                (selectItem)="trainerSelect($event)"
                (blur)="trainerBlurHandler($event)"
                [editable]="false"
                (focus)="trainerFocusHandler()"
                #instance="ngbTypeahead"
                class="trainerAutoComplete"
                popupClass="trainersDropDownList"
              />

            </div>
<!--            <div-->
<!--              class="col linkToTrainerDescription"-->
<!--              *ngIf="form.get('trainer').value"-->
<!--            >-->
<!--              Сведения о тренере-->
<!--            </div>-->
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="email">Кий</label>
            </div>
            <div class="col">
              <input
                type="text"
                name="cue"
                id="cue"
                placeholder=""
                formControlName="cue"
                (keydown)="blurOnEnter($event)"
              />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <label for="email">Фото</label>
            </div>
            <div
              class="col"
              style="display: flex; align-content: center; align-items: center;"
            >
              <input
                type="file"
                name="image"
                id="image"
                accept="image/*"
                (change)="onFileSelect($event)"
                style="display: none"
              />
              <input
                type="button"
                value="Выбрать файл"
                (click)="clickOnInvisibleInput()"
              />
              <div
                *ngIf="imageSrc"
                style="width: 50px!important; height: 50px!important; margin-left: 10px; flex-shrink: 0"
              >
                <img
                  src="{{imageSrc}}"
                  alt="No image?"
                  style="width: 100%; height: 100%;"
                >
              </div>
              <div
                class="fileNameCaptionStyle"
              >
                {{imageNameToDisplay}}
              </div>
            </div>
            <div class="col-12 text-danger extraErrorsStyles" *ngIf="errors.email">
              <div *ngFor="let error of errors.email">{{ error }}</div>
            </div>
          </div>
          <div
            class="form-group"
            *ngIf="!edit"
          >
            <button
              type="button"
              [ngClass]="buttonStyle()"
              [disabled]="submitButtonDisabled()"
              (click)="create()"
            >
              Создать и зарегистрировать
            </button>
          </div>
          <div class="form-group" *ngIf="edit">
            <button
              type="button"
              [ngClass]="buttonStyle()"
              [disabled]="submitButtonDisabled()"
              (click)="update()"
            >
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
